// src/components/Dashboard.js
import React from "react";
import {
  Box,
  Heading,
  HStack,
  Grid,
  GridItem,
  useTheme,
  Button,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { VaccineStock } from "./dashboard/VacineStock";
import { VaccineStockExp } from "./dashboard/VacineStockExp";
import { VaccineOrdersStackedBar } from "./dashboard/VaccineOrdersStackedBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileLines,
  faFileSignature,
  faScrewdriverWrench,
  faSyringe,
} from "@fortawesome/free-solid-svg-icons";
import { ProductionAndDeliveryChart } from "./dashboard/ProductionAndDeliveryChart";
import { VaccineDemandPieChart } from "./dashboard/VaccineDemandPieChart";
import Header from "../components/Header";
import InventorySummaryTable from "./dashboard/InventorySummaryTable";
import { InventoryBarChart } from "./dashboard/InventoryBarChart";
import { InventoryPieChart } from "./dashboard/InventoryPieChart";
import { BookingAndSalesChart } from "./dashboard/BookingAndSalesChart";
import VaccineReceiptDashboard from "./dashboard/VaccineReceiptDashboard";
import VaccineRecReq from "./dashboard/VaccineRecReq";
import VaccineDistribution from "./dashboard/VaccineDistribution";
import { StandardHeader } from "../themes/StandardHeader";

const VaccineUsageOverview = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      p={{ base: 4, md: 8, lg: 15 }} // Responsive padding
      m={{ base: 2, md: 4, lg: 15 }} // Responsive margin
      w="100%"
      overflowX="auto" // Handle horizontal overflow
    >
      <Box
        mb={5}
        borderRadius="full"
        w="100%"
        bgColor="iBlue.600"
        color="white"
        p={{ base: 2, md: 3 }} // Responsive padding
      >
        <HStack spacing={{ base: 3, md: 5 }} ml={{ base: 3, md: 5 }}>
          <FontAwesomeIcon
            icon={faSyringe}
            color="white"
            size={{ base: "lg", md: "xl" }} // Responsive icon size
          />
          <Heading
            as="h1"
            size={{ base: "sm", md: "md", lg: "lg" }} // Responsive heading size
            fontWeight="normal"
          >
            ภาพรวมการใช้วัคซีน
          </Heading>
        </HStack>
      </Box>
      <Box w="full" p={{ base: 2, md: 5 }}>
        {/* First Grid: Booking and Sales + Production and Delivery */}
        <Grid
          templateColumns={{
            base: "1fr", // 1 column on mobile
            md: "repeat(2, 1fr)", // 2 columns on tablet and above
          }}
          gap={{ base: 4, md: 6, lg: 10 }} // Responsive gap
          m={{ base: 2, md: 5 }}
        >
          <GridItem
            bg="white"
            p={{ base: 3, md: 4 }} // Responsive padding
            borderRadius="md"
            boxShadow="md"
          >
            <BookingAndSalesChart />
          </GridItem>
          <GridItem
            bg="white"
            p={{ base: 3, md: 4 }} // Responsive padding
            borderRadius="md"
            boxShadow="md"
          >
            <ProductionAndDeliveryChart />
          </GridItem>
        </Grid>
        {/* Second Grid: Vaccine Demand Pie Charts */}
        <Grid
          templateColumns={{
            base: "1fr", // 1 column on mobile
            sm: "repeat(2, 1fr)", // 2 columns on small screens
            lg: "repeat(3, 1fr)", // 3 columns on desktop
          }}
          gap={{ base: 4, md: 6, lg: 10 }} // Responsive gap
          m={{ base: 2, md: 5 }}
        >
          {["pig", "cow", "poultry"].map((type) => (
            <GridItem
              key={type}
              bg="white"
              p={{ base: 3, md: 4 }} // Responsive padding
              borderRadius="md"
              boxShadow="md"
            >
              <VaccineDemandPieChart type={type} />
            </GridItem>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default VaccineUsageOverview;